import type { MutationClass, ToolingState } from '../../../models'

export class SetPaginationStateMutation implements MutationClass {
  static execute(this: void, state: ToolingState, pagination: ToolingState['pagination']): void {
    state.pagination = pagination
  }
}
